export default "__VITE_ASSET__DpPystll__"